<mat-toolbar
  class="header"
  [class.logged-in]="authService.isLoggedIn()"
  [ngClass]="{ 'no-menu': !showMenu }"
  >
  <div class="header-container">
    <div class="header-wrapper-1">
      @if (showMenu) {
        <button mat-icon-button (click)="drawerService.toggle()">
          <mat-icon>menu</mat-icon>
        </button>
      }

      <img
        src="{{ logoLink }}"
        class="logo"
        [ngClass]="{ 'dynamic-logo': authService.isLoggedIn() }"
        (click)="goToDefault()"
        />
      </div>

      <div class="header-wrapper-2">
        <button mat-flat-button [matMenuTriggerFor]="language" class="lang-btn">
          @if (translate.currentLang === 'en') {
            <span>EN</span>
          }
          @if (translate.currentLang !== 'en') {
            <span>BM</span>
          }

          <img src="assets/image/language2.png" alt="" clas="pt-sm" />

        </button>


        <div class="profile-avatar">
          @if (userService?.user) {
            <mat-chip-set>
              <mat-chip [matMenuTriggerFor]="menu">
                {{ userService?.user?.name }}
              </mat-chip>
            </mat-chip-set>
          }
        </div>

        @if (!showMenu && isShowWhatsapp) {
          <div
            class="whatsapp-btn"
            (click)="whatsappRedirect()"
            >
            <img
              src="assets/icons/whatsapp_icon_unfiltered.png"
              alt="Whatsapp Logo"
              />
              <div>WhatsApp</div>
            </div>
          }
        </div>
      </div>
    </mat-toolbar>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="authService.changePassword()">
        {{ "auth.changePass" | translate }}
      </button>
      <button mat-menu-item (click)="authService.logout()">Logout</button>
    </mat-menu>

    <mat-menu #language="matMenu">
      <button mat-menu-item (click)="switchLanguage('en')">
        <span>EN</span>
      </button>
      <button mat-menu-item (click)="switchLanguage('bm')">
        <span>BM</span>
      </button>
    </mat-menu>
